// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"22100f37","453":"38afd6f6","560":"c7ea116a"}[chunkId] + ".chunk.js";
};